import React from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledTooltip } from "reactstrap";

import { LiveLectureDto } from "../../interfaces";
import { buildLiveLectureEventSummary } from "./liveLectureCalendarUtils";
import { LiveLectureStatusDot } from "./LiveLectureStatusDot";

type TProps = {
  event: {
    id: string;
    title: string;
    resource?: LiveLectureDto;
  };
};

export const LiveLectureCalendarEvent: React.FC<TProps> = ({ event }) => {
  const { t, i18n } = useTranslation();
  const lecture = event.resource;
  const tooltipId = `live-lecture-event-${event.id}`;

  return (
    <React.Fragment>
      <span
        id={tooltipId}
        className="d-inline-flex align-items-center gap-1 w-100 text-truncate"
      >
        {lecture && (
          <LiveLectureStatusDot status={lecture.status} size={9} outlined />
        )}
        <span className="text-truncate">{event.title}</span>
      </span>
      {lecture && (
        <UncontrolledTooltip target={tooltipId} placement="top">
          <div className="text-start" style={{ whiteSpace: "pre-line" }}>
            {buildLiveLectureEventSummary(lecture, t, i18n.language)}
          </div>
        </UncontrolledTooltip>
      )}
    </React.Fragment>
  );
};
